import { AddJobState } from "../model";

// To clear input field
export const clearFields = (state: AddJobState) => {
  state.inputs.position = "";
  state.inputs.company = "";
  state.inputs.jobLocation = "";
  state.inputs.jobStatus = "";
  state.inputs.jobDescription = "";
  state.inputs.jobType = "";
};
